import { Component, Input, OnInit } from '@angular/core';
import { RecentTicket } from 'src/app/models/core/recent-ticket.model';
import { ticketCardPaymentMethodLabel } from 'src/app/utils/payment-labels';
import { getProductIcon } from 'src/app/types/product-type-icon.map';
import { ModalController } from '@ionic/angular';
import { TicketOptionsModalComponent } from '../../modals/ticket-options-modal/ticket-options-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-card',
  templateUrl: './ticket-card.component.html',
  styleUrls: ['./ticket-card.component.scss'],
  standalone: false
})
export class TicketCardComponent implements OnInit {

  @Input() ticket!: RecentTicket;
  @Input() eventId!: number;
  @Input() icon: string = 'assets/icons/ticket.svg';
  @Input() onTicketDeleted?: () => void;

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.icon = getProductIcon(this.ticket?.product?.product_type);
  }

  shouldShowReference(ticket: RecentTicket): boolean {
    const ref = ticket.reference || '';
    return !ticket.ecommerce && ref.toUpperCase() !== 'SIN REFERENCIA';
  }

  /** Cobrado en boletería: en venta directa es lo único del medio de pago que vale mostrar. */
  isPayAtDoor(ticket: RecentTicket): boolean {
    return ticket.payment_method === 'pay_at_door';
  }

  getTicketAmount(ticket: RecentTicket): number {
    return ticket.price_product ? ticket.price_product * ticket.quota : 0;
  }

  /** Lo cobrado en la transacción; sin transacción (pago en puerta) se calcula por precio × cupo. */
  getPaidAmount(ticket: RecentTicket): number {
    return ticket.latest_transaction?.amount ?? this.getTicketAmount(ticket);
  }

  getPaymentMethodLabel(method: string | null | undefined): string {
    return ticketCardPaymentMethodLabel(method, key => this.translate.instant(key));
  }

  async openOptionsModal() {
    const modal = await this.modalCtrl.create({
      component: TicketOptionsModalComponent,
      componentProps: {
        ticket: this.ticket,
        eventId: this.eventId,
        onTicketDeleted: this.onTicketDeleted
      },
      breakpoints: [0, 0.5, 0.95],
      initialBreakpoint: 0.25,
      cssClass: 'custom-modal-options',
      handle: true
    });
    await modal.present();
  }

  getLatestPetition(ticket: RecentTicket) {
    return ticket.latest_petition ?? null;
  }

  getPetitionLabel(petition: RecentTicket['latest_petition']): string {
    if (!petition) return '';

    const status = (petition.status ?? '').toLowerCase();
    const type = (petition.type ?? '').toLowerCase();

    if (status === 'pending') {
      return type === 'edit'
        ? this.translate.instant('petitions.pending-edit')
        : this.translate.instant('petitions.pending-delete');
    }

    if (status === 'approved') {
      return type === 'edit'
        ? this.translate.instant('petitions.approved')
        : this.translate.instant('petitions.approved-delete');
    }

    if (status === 'rejected') {
      return type === 'edit'
        ? this.translate.instant('petitions.rejected-edit')
        : this.translate.instant('petitions.rejected-delete');
    }

    return '';
  }

}